export const mapArrayOfMapsTo2dArray = (objectArray: Map<string, string>[]) =>
  objectArray.map(map => Array.from(map.keys()).map(key => map.get(key)));
